import { FC, useCallback, useContext, useState } from 'react';

import { message } from 'antd';

import { scrollToTop, StepButtons } from '../../../../../../shared/components';
import { WizardDataFormContext } from '../../../Wizard/contexts/WizardDataForm';
import { StepThreeFormContext } from '../../../Steps/StepThree/contexts/StepThreeForm';
interface PreliquidationStepButtonsProps {
  label?: string;
  showGoBack?: boolean;
  onClick?: () => void;
  onPressBackButton?: () => void;
  htmlType?: 'submit' | 'button';
}

export const PreliquidationStepButtons: FC<PreliquidationStepButtonsProps> = ({
  label = 'Continuar',
  showGoBack = true,
  onClick = () => {},
  onPressBackButton = () => {},
  htmlType = 'submit',
}) => {
  const { setCanShowConfirmIssue, setShowSecondaryButton } = useContext(WizardDataFormContext);
  const { paymentMethodsDataTable, postSavePreliquidation, proccessPayments} = useContext(StepThreeFormContext);
  
  const [isSavingPreliquidation, setIsSavingPreliquidation] = useState<boolean>(false);

  const showSavePreliquidation = label === 'Confirmar el pago';

  const onPressBack = () => {
    onPressBackButton();
    scrollToTop();
  };

  const onPressClick = () => {
    onClick();
    scrollToTop();
  };

  const onClickSavePreliquidation = useCallback(async () => {
    setIsSavingPreliquidation(true);
    scrollToTop();
    try {
      if(!paymentMethodsDataTable.length) {
        message.error('Para guardar el pago primero debe agregar por lo menos una forma de pago.');
        return;
      }

      const paymentsProcesedResponse = await proccessPayments();
      if (!paymentsProcesedResponse) return;

      await postSavePreliquidation();

      setCanShowConfirmIssue(true);
      setShowSecondaryButton(true);

    } catch (error) {} 
    finally {
      setIsSavingPreliquidation(false);
    }
  }, [setCanShowConfirmIssue, setShowSecondaryButton, paymentMethodsDataTable, postSavePreliquidation]);

  return (
    <StepButtons
      showGoBackButton={showGoBack}
      onPressBackButton={onPressBack}
      onPressConfirmButton={onPressClick}
      primaryButton={{label}}
      secondaryButton={
        showSavePreliquidation
          ? {
              label: 'Guardar',
              onClick: onClickSavePreliquidation,
              loading: isSavingPreliquidation,
              disabled: isSavingPreliquidation || !paymentMethodsDataTable.length,
              type: 'secondary', 
              className: isSavingPreliquidation || !paymentMethodsDataTable.length ? 'opacity-low' : '',
            }
          : undefined
      }
      htmlTypeConfirmButton={htmlType}
    />
  );
};
